import React, { useState } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { ComboBox } from "@progress/kendo-react-dropdowns";
import { filterBy } from "@progress/kendo-data-query";
import { Modal } from "react-bootstrap";
import { DatePicker } from "antd";
import dayjs from "dayjs";
import { useSelector, useDispatch } from "react-redux";
import DropDownField from "../../Shared/DropdownField";
import MainLayout from "../layout";
import TextField from "../../Shared/TextField";
import KendoTicketGrid from "./KendoTicketGrid";
import { TICKET_TASK_FILTERS } from "../../constants/TicketTaskFilter";
import {
  setFollowDays,
  setFromDate,
  setStatusDays,
  setTargetDate,
  setTicketTaskAllFilters,
  setToDate,
} from "../../store/reducers/TicketTaskFilter";
import { keyRestrict } from "../../utils/array";
import { DisplayMsg } from "../../services/toastService";
import {
  setHeaderRerender,
  setQuickData,
  setQuickSearch,
} from "../../store/reducers/SharedLayoutDataSlice";
import { BASE_FILE_URL, setUrl } from "../../handlers";

const Tickets = (props) => {
  const dispatch = useDispatch();

  const dropDownData = useSelector((state) => state.DropdownList);
  const ticketTaskFilter = useSelector((state) => state.ticketTaskFilter);

  const [showFilterModal, setShowFilterModal] = useState(false);

  const [TicketDate, setTicketDate] = useState({
    fromDate: null,
    fromTargetDate: null,
    toDate: null,
    toTargetDate: null,
    updatedFrom: null,
    updatedTo: null,
  });

  const [CustomerData, setCustomerData] = useState(
    dropDownData.CustomersList.slice()
  );
  const [ClientData, setClientData] = useState(
    dropDownData.ClientsList.slice()
  );

  const [ticketData, setTicketData] = useState({
    type: ticketTaskFilter.type ?? ticketTaskFilter.type,
    keywords: ticketTaskFilter.keyword ?? ticketTaskFilter.keyword,
    status: ticketTaskFilter.status ?? ticketTaskFilter.status,
    statusDays: ticketTaskFilter.statusDays ?? ticketTaskFilter.statusDays,
    followDays: ticketTaskFilter.followDays ?? ticketTaskFilter.followDays,
    teamCategory:
      ticketTaskFilter.teamCategory ?? ticketTaskFilter.teamCategory,
    assignee: ticketTaskFilter.assignee ?? ticketTaskFilter.assignee,
    priority: ticketTaskFilter.priority ?? ticketTaskFilter.priority,
    client:
      ticketTaskFilter.clientId != null && ticketTaskFilter.clientId !== ""
        ? {
          text: ticketTaskFilter.customerId,
          value: ticketTaskFilter.customerId,
        }
        : "",
    fromDate: ticketTaskFilter.fromDate ?? ticketTaskFilter.fromDate,
    toDate: ticketTaskFilter.toDate ?? ticketTaskFilter.toDate,
    custAccNum:
      ticketTaskFilter.customerId != null && ticketTaskFilter.customerId !== ""
        ? {
          text: ticketTaskFilter.customerId,
          value: ticketTaskFilter.customerId,
        }
        : "",
    suspended: ticketTaskFilter.suspended ?? ticketTaskFilter.suspended,
    team: ticketTaskFilter.team ?? ticketTaskFilter.team,
    internalAssignee:
      ticketTaskFilter.internalAssignee ?? ticketTaskFilter.internalAssignee,
    impManger: ticketTaskFilter.impManger ?? ticketTaskFilter.impManger,
    reporter: ticketTaskFilter.reporter ?? ticketTaskFilter.reporter,
    priorityClient:
      ticketTaskFilter.priorityClient ?? ticketTaskFilter.priorityClient,
    ticketCategory:
      ticketTaskFilter.ticketCategory ?? ticketTaskFilter.ticketCategory,
  });

  const HandleShow = () => {
    setShowFilterModal(true);
  };

  const FilterTickets = () => {
    setShowFilterModal(false);
    dispatch(setHeaderRerender(Date.now()));
    dispatch(setQuickData(""));
    dispatch(setQuickSearch(false));
    dispatch(
      setTicketTaskAllFilters({
        type: ticketData?.type ?? "",
        keyword: ticketData?.keywords ?? "",
        status: ticketData?.status ?? "",
        overDue: ticketData?.overDue ?? "",
        statusDays: ticketData?.statusDays ?? "",
        followDays: ticketData?.followDays ?? "",
        targetDate: ticketData?.targetDate ?? "",
        assignee: ticketData?.assignee ?? "",
        suspended: ticketData?.suspended ?? "",
        practiceName: ticketData?.practiceName ?? "",
        priority: ticketData?.priority ?? "",
        internalAssignee: ticketData?.internalAssignee ?? "",
        customerId: ticketData?.custAccNum ? ticketData?.custAccNum.value : "",
        clientId: ticketData?.client?.value ?? "",
        priorityClient: ticketData?.priorityClient ?? "",
        team: ticketData?.team ?? "",
        cp: ticketData?.cp ?? "",
        reseller: ticketData?.reseller ?? "",
        entityId: ticketData?.entityId ?? "",
        impManger: ticketData?.impManger ?? "",
        reporter: ticketData?.reporter ?? "",
        ticketCategory: ticketData?.ticketCategory ?? "",
        fromDate: ticketData?.fromDate_Value ?? "",
        toDate: ticketData?.toDate_Value ?? "",
        teamCategory: ticketData?.teamCategory ?? "",
        currentPage: 1,
      })
    );
    setShowFilterModal(false);
  };

  const ExportExcel = async () => {
    try {
      const formData = new FormData();
      document.getElementById("loader").style.display = "block";
      const ticket = ticketTaskFilter;
      const sortBy = "CREATED_DATE";
      const sortorder = "desc";

      formData.append("TXTALLKEYWORDS", ticket.keyword ?? "");
      formData.append("TXTALLSTATUS", ticket.status ?? "");
      formData.append("ddlDteam", ticket.team ?? "");
      formData.append("TXTALLASSIGNEE", ticket.assignee ?? "");
      formData.append("TXTPRACTICENAME", ticket.practiceName ?? "");
      formData.append("TXTALLPRIORITY", ticket.priority ?? "");
      formData.append("teamCategory", ticket.teamCategory ?? "");
      formData.append("suspended", ticket.suspended ?? "");
      formData.append("client", ticket.clientId ?? "");
      formData.append("CustAccNum", ticket.customerId ?? "");
      formData.append("FromDate", ticket.fromDate ?? "");
      formData.append("ToDate", ticket.toDate ?? "");
      formData.append("txtAllInternalAssignee", ticket.internalAssignee ?? "");
      formData.append("sortname", sortBy);
      formData.append("sortorder", sortorder);
      formData.append("userType", sessionStorage.type);
      formData.append("CP", sessionStorage.CP);
      formData.append("Reseller", sessionStorage.Reseller);
      const response = await fetch(
        setUrl("DASHBOARD", "EXPORTTICKETSREPORT", true),
        {
          method: "POST",
          body: formData,
        }
      );
      const result = await response.json();
      if (result.status) {
        DownloadChartFiles(result.Path, result.File);
      } else {
        DisplayMsg("2", result.Message);
      }
      document.getElementById("loader").style.display = "none";
    } catch (e) {
      DisplayMsg("2", "Unable to Process the Request");
      document.getElementById("loader").style.display = "none";
    }
  };

  const DownloadChartFiles = (filepath, fileName) => {
    const updatedUrl = `${BASE_FILE_URL}${filepath}&filename=${fileName}`;
    const a = document.createElement("a");
    a.href = updatedUrl;
    a.download = fileName;
    a.target = "_blank";
    a.click();

    document.getElementById("loader").style.display = "none";
  };

  const ClearTicketState = () => {
    setTicketData((prevData) => ({
      ...prevData,
      type: "Ticket",
      keywords: "",
      status: "I",
      statusDays: "",
      teamCategory: "",
      assignee: "",
      priority: "",
      followDays: "",
      client: "",
      fromDate: "",
      toDate: "",
      custAccNum: "",
      suspended: "",
      team: "",
      internalAssignee: "",
      impManger: "",
      reporter: "",
      priorityClient: "",
      ticketCategory: "",
    }));
  };

  const ResetFilter = () => {
    ClearTicketState();
    // dispatch(setQuickData(""));
    // dispatch(setQuickSearch(false));
    // dispatch(clearTicketTaskFilters());
  };

  const AlterTicketDate = (dateVal, name) => {
    if (dateVal != null) {
      if (name === "fromDate") {
        setTicketData((prevData) => ({
          ...prevData,
          fromDate: dateVal.$d.toLocaleDateString(),
        }));
        // dispatch(setFromDate(dateVal.$d.toLocaleDateString()));
      }

      if (name === "toDate") {
        setTicketData((prevData) => ({
          ...prevData,
          toDate: dateVal.$d.toLocaleDateString(),
        }));

        // dispatch(setToDate(dateVal.$d.toLocaleDateString()));
      }

      setTicketData((prevData) => ({
        ...prevData,
        [name]: dateVal,
        [`${name}_` + `Value`]: new Date(dateVal).toLocaleDateString(),
      }));
    } else {
      if (name === "fromDate") {
        dispatch(setFromDate(""));
      }

      if (name === "toDate") {
        dispatch(setToDate(""));
      }

      setTicketData((prevData) => ({
        ...prevData,
        [name]: null,
        [`${name}_` + `Value`]: "",
      }));
    }
  };

  const FilterCustomer = (filter) => {
    const data = dropDownData.CustomersList.slice();
    return filterBy(data, filter);
  };

  const AlterCustomer = (event) => {
    let updatedCustomers = [];
    const newCustomer =
      event.filter.value.length > 2
        ? FilterCustomer(event.filter)
        : dropDownData.CustomersList.slice();
    updatedCustomers = [...new Set(newCustomer)];
    setCustomerData(updatedCustomers);
  };

  const FilterClient = (filter) => {
    const data = dropDownData.ClientsList.slice();
    return filterBy(data, filter);
  };

  const AlterClient = (event) => {
    let updatedClient = [];
    const newClient =
      event.filter.value.length > 2
        ? FilterClient(event.filter)
        : dropDownData.ClientsList.slice();
    updatedClient = [...new Set(newClient)];
    setClientData(updatedClient);
  };

  const AlterComboBoxData = (event) => {
    const curVal = event.target.value;
    const fieldName = event.target.name;
    setTicketData((prevData) => ({
      ...prevData,
      [fieldName]: curVal,
    }));
  };

  const ShowGridTitle = () => {
    const currentStatus = ticketTaskFilter.type;
    let titleName;
    if (currentStatus === "A") {
      titleName = "Tickets/Tasks";
    } else if (currentStatus === "Ticket") {
      titleName = "Tickets";
    } else if (currentStatus === "Task") {
      titleName = "Task";
    } else if (ticketData.type === "A") {
      titleName = "Tickets/Tasks";
    }
    return titleName;
  };

  const AlterDateValues = (e) => {
    keyRestrict(e, "0123456789");
    if (e.target.value.length <= 10) {
      setTicketDate((dateInfo) => ({
        ...dateInfo,
        [e.target.name]: e.target.value,
      }));
    }
  };

  const AlterDateKeyUp = (e) => {
    keyRestrict(e, "0123456789");
    if (e.target.value.length <= 10) {
      setTicketDate((dateInfo) => ({
        ...dateInfo,
        [e.target.name]: e.target.value,
      }));
    }
  };

  const FieldData = (textField) => {
    const name = textField.fieldName;
    const value = textField.fieldValue ? textField.fieldValue.trim() : "";

    if (name === "type") {
      ClearTicketState();
      // dispatch(clearTicketTaskFilters());
      if (value === "Task") {
        setTicketData((prevData) => ({
          ...prevData,
          status: "",
        }));
        // dispatch(setStatus(""));
      } else {
        setTicketData((prevData) => ({
          ...prevData,
          status: "I",
        }));
      }
    } else if (name === "status") {
      dispatch(setTargetDate(""));
      dispatch(setFollowDays(""));
      dispatch(setStatusDays(""));
    } else if (
      name === "statusDays" &&
      (ticketData.status === "R" ||
        ticketData.status === "C" ||
        ticketData.status === "I" ||
        ticketData.status === "Q")
    ) {
      // statusDays: value,
      setTicketData((prevData) => ({
        ...prevData,
        followDays: "",
      }));

      // dispatch(setFollowDays(""));
      // dispatch(setStatusDays(value));
    } else if (name === "statusDays" && ticketData.status === "FU") {
      dispatch(setFollowDays(value));
    } else if (name === "priorityClient") {
      // dispatch(setPriorityClient(value));
    }

    setTicketData((prevData) => ({
      ...prevData,
      [textField.fieldName]: textField.fieldValue,
    }));
  };

  const FieldValue = (fieldName) => {
    let fieldValue;
    if (fieldName === "fromDate" || fieldName === "toDate") {
      fieldValue =
        ticketData[fieldName] != null && ticketData[fieldName] !== ""
          ? dayjs(ticketData[fieldName])
          : "";
    } else {
      fieldValue = ticketData[fieldName] != null ? ticketData[fieldName] : "";
    }
    return fieldValue;
  };

  return (
    <MainLayout>
      <div role="tabpanel" className="tab-pane page-content-wrapper">
        <div className="table-panel" id="ticket-table-panel">
          <div className="row table-panel-header">
            <div className="col-md-8 col-sm-12">
              <h6> {ShowGridTitle()} </h6>
            </div>
            <div className="col-md-4 col-sm-12 flex-center-end">
              <div className="popuop_open">
                <span
                  className="popuop_button"
                  role="button"
                  onClick={HandleShow}
                  style={{
                    cursor: "pointer",
                    textDecoration: "none",
                    color: "#007bff",
                    marginLeft: "10px",
                    marginTop: "5px",
                    padding: "5px",
                    borderRadius: "5px",
                    backgroundColor: "#f8f9fa",
                    border: "1px solid #007bff",
                  }}
                >
                  <FontAwesomeIcon icon="filter" size="lg" />
                </span>
              </div>

              {(ticketTaskFilter.type === "Ticket" ||
                ticketTaskFilter.type === "A") && (
                  <div className="float-end">
                    <input
                      type="button"
                      className="btnLinkGreen"
                      value="Export Excel"
                      onClick={() => ExportExcel()}
                    />
                  </div>
                )}

              <Modal
                show={showFilterModal}
                onHide={() => setShowFilterModal(false)}
                backdrop="static"
                style={{ top: "8%" }}
              >
                <Modal.Header closeButton>
                  <div className="row w-100 justify-content-center">
                    <div className="col-md-10 col-sm-10">
                      <Modal.Title className="modal-title text-center pl-8 ml-8">
                        Ticket/Task Filter
                      </Modal.Title>
                    </div>

                    <div className="col-md-2 col-sm-2 m-auto">
                      <input
                        type="button"
                        className="white-btn"
                        value="Reset All"
                        onClick={() => ResetFilter()}
                      />
                    </div>
                  </div>
                </Modal.Header>
                <Modal.Body>
                  <div className="content">
                    <div className="popup__body">
                      <div className="row">
                        <div className="col-md-4 col-sm-4">
                          <DropDownField
                            id="type"
                            bold
                            classDiv
                            label="Type"
                            required={false}
                            options={TICKET_TASK_FILTERS.FILTER_TYPES}
                            value={FieldValue("type")}
                            ReceivedTextData={FieldData}
                          />
                        </div>

                        <div className="col-md-4 col-sm-4">
                          <TextField
                            id="keywords"
                            bold
                            length={255}
                            label="Keywords"
                            ReceivedTextData={FieldData}
                            value={FieldValue("keywords")}
                            required={false}
                          />
                        </div>

                        {ticketData.type === "Ticket" && (
                          <div className="col-md-4 col-sm-4">
                            <DropDownField
                              id="status"
                              bold
                              label="Status"
                              classDiv
                              required={false}
                              options={TICKET_TASK_FILTERS.STATUS_TICKETS}
                              value={FieldValue("status")}
                              ReceivedTextData={FieldData}
                            />
                          </div>
                        )}

                        {ticketData.type === "Task" && (
                          <div className="col-md-4 col-sm-4">
                            <DropDownField
                              id="status"
                              bold
                              label="Status"
                              classDiv
                              required={false}
                              options={TICKET_TASK_FILTERS.STATUS_TASKS}
                              value={FieldValue("status")}
                              ReceivedTextData={FieldData}
                            />
                          </div>
                        )}

                        {ticketData.type === "A" && (
                          <div className="col-md-4 col-sm-4">
                            <DropDownField
                              id="status"
                              bold
                              label="Status"
                              classDiv
                              required={false}
                              options={TICKET_TASK_FILTERS.STATUS_ALL}
                              value={FieldValue("status")}
                              ReceivedTextData={FieldData}
                            />
                          </div>
                        )}

                        <div className="col-md-4 col-sm-4">
                          <DropDownField
                            id="statusDays"
                            bold
                            label="Days"
                            classDiv
                            required={false}
                            options={TICKET_TASK_FILTERS.STATUS_DAYS_OPTIONS}
                            value={FieldValue("statusDays")}
                            ReceivedTextData={FieldData}
                          />
                        </div>

                        {ticketData.type === "Ticket" && (
                          <div className="col-md-4 col-sm-4">
                            <DropDownField
                              id="teamCategory"
                              bold
                              label="Team Category"
                              classDiv
                              required={false}
                              options={TICKET_TASK_FILTERS.CATEGORY_OPTIONS}
                              value={FieldValue("teamCategory")}
                              ReceivedTextData={FieldData}
                            />
                          </div>
                        )}
                        <div className="col-md-4 col-sm-4">
                          <TextField
                            id="assignee"
                            bold
                            length={255}
                            label="Assignee"
                            ReceivedTextData={FieldData}
                            value={FieldValue("assignee")}
                            required={false}
                          />
                        </div>
                        <div className="col-md-4 col-sm-4">
                          <DropDownField
                            id="priority"
                            bold
                            label="Priority"
                            classDiv
                            required={false}
                            options={TICKET_TASK_FILTERS.PRIORITY_OPTIONS}
                            value={FieldValue("priority")}
                            ReceivedTextData={FieldData}
                          />
                        </div>
                        <div className="col-md-4 col-sm-4">
                          <div className="textBoxValidate field-container">
                            <label className="field-placeholder font-medium">
                              Practice Name
                            </label>
                            <ComboBox
                              className="field-input"
                              data={ClientData}
                              value={
                                FieldValue("client") === ""
                                  ? null
                                  : FieldValue("client")
                              }
                              name="client"
                              textField="text"
                              filterable
                              onFilterChange={AlterClient}
                              onChange={AlterComboBoxData}
                            />
                          </div>
                        </div>

                        {ticketData.type === "Ticket" && (
                          <>
                            <div className="col-md-4 col-sm-4">
                              <div className="textBoxValidate field-container overflow-visible">
                                <label className="field-placeholder font-medium">
                                  From Date
                                </label>

                                <DatePicker
                                  value={FieldValue("fromDate")}
                                  onChange={(data) =>
                                    AlterTicketDate(data, "fromDate")
                                  }
                                  name="fromDate"
                                  format="MM/DD/YYYY"
                                  placeholder="MM/DD/YYYY"
                                />

                                <span
                                  className="requiredFld"
                                  style={{ display: "none" }}
                                >
                                  Invalid Date
                                </span>
                              </div>
                            </div>
                            <div className="col-md-4 col-sm-4">
                              <div className="field-container overflow-visible">
                                <label className="field-placeholder font-medium">
                                  To Date
                                </label>

                                <DatePicker
                                  value={FieldValue("toDate")}
                                  onChange={(data) =>
                                    AlterTicketDate(data, "toDate")
                                  }
                                  name="toDate"
                                  className="field-input"
                                  format="MM/DD/YYYY"
                                  placeholder="MM/DD/YYYY"
                                  onKeyDown={(e) => AlterDateValues(e)}
                                  onKeyUp={(e) => AlterDateKeyUp(e)}
                                />

                                <span
                                  className="requiredFld"
                                  style={{ display: "none" }}
                                >
                                  Invalid Date
                                </span>
                              </div>
                            </div>
                          </>
                        )}
                        <div className="col-md-4 col-sm-4">
                          <div className="textBoxValidate field-container">
                            <label className="field-placeholder font-medium">
                              Customer Id
                            </label>
                            <ComboBox
                              className="field-input"
                              data={CustomerData}
                              value={
                                FieldValue("custAccNum") === ""
                                  ? null
                                  : FieldValue("custAccNum")
                              }
                              name="custAccNum"
                              textField="text"
                              filterable
                              onFilterChange={AlterCustomer}
                              onChange={AlterComboBoxData}
                            />
                          </div>
                        </div>
                        {ticketData.type === "Ticket" && (
                          <div className="col-md-4 col-sm-4">
                            <DropDownField
                              id="suspended"
                              bold
                              classDiv
                              label="Suspended"
                              required={false}
                              options={TICKET_TASK_FILTERS.SUSPENDED_OPTIONS}
                              value={FieldValue("suspended")}
                              ReceivedTextData={FieldData}
                            />
                          </div>
                        )}

                        <div className="col-md-4 col-sm-4">
                          <DropDownField
                            id="team"
                            bold
                            label="Team"
                            classDiv
                            required={false}
                            options={dropDownData.TeamsList}
                            value={FieldValue("team")}
                            ReceivedTextData={FieldData}
                          />
                        </div>

                        <div className="col-md-4 col-sm-4">
                          <TextField
                            id="internalAssignee"
                            bold
                            length={255}
                            label="Internal Assignee"
                            ReceivedTextData={FieldData}
                            value={FieldValue("internalAssignee")}
                            required={false}
                          />
                        </div>

                        {ticketData.type === "Ticket" && (
                          <>
                            <div className="col-md-4 col-sm-4">
                              <TextField
                                id="impManger"
                                bold
                                length={255}
                                label="Implementation Manager"
                                ReceivedTextData={FieldData}
                                value={FieldValue("impManger")}
                                required={false}
                              />
                            </div>
                            <div className="col-md-4 col-sm-4">
                              <TextField
                                id="reporter"
                                bold
                                length={255}
                                label="Reporter"
                                ReceivedTextData={FieldData}
                                value={FieldValue("reporter")}
                                required={false}
                              />
                            </div>
                          </>
                        )}

                        {ticketData.type === "Ticket" && (
                          <div className="col-md-4 col-sm-4">
                            <DropDownField
                              id="priorityClient"
                              bold
                              classDiv
                              label="Priority Clients"
                              required={false}
                              options={
                                TICKET_TASK_FILTERS.PRIORITY_CLIENTS_OPTIONS
                              }
                              value={FieldValue("priorityClient")}
                              ReceivedTextData={FieldData}
                            />
                          </div>
                        )}

                        {ticketData.type === "Ticket" && (
                          <div className="col-md-4 col-sm-4">
                            <DropDownField
                              id="ticketCategory"
                              bold
                              label="Ticket Category"
                              classDiv
                              required={false}
                              options={TICKET_TASK_FILTERS.TICKET_CATEGORIES}
                              value={FieldValue("ticketCategory")}
                              ReceivedTextData={FieldData}
                            />
                          </div>
                        )}
                      </div>
                    </div>
                  </div>
                  <div className="row text-center">
                    <div className="col-md-12 col-sm-12">
                      <label>&nbsp;</label>
                      <input
                        type="button"
                        className="btnLinkBlue"
                        value="Search"
                        onClick={() => FilterTickets()}
                      />
                      <input
                        type="button"
                        className="btnCancel ClosePopup"
                        value="Cancel"
                        onClick={() => setShowFilterModal(false)}
                      />
                    </div>
                  </div>
                </Modal.Body>
              </Modal>
            </div>
          </div>
          <div className="table-panel-body">
            <KendoTicketGrid type={ticketData.type} />
          </div>
        </div>
      </div>
    </MainLayout>
  );
};
export default Tickets;
